(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DashboardKibana', DashboardKibana);

    DashboardKibana.$inject = ['$resource'];

    function DashboardKibana ($resource) {
        var service = $resource('api/kibana-proxy/cookies', {}, {
        });
        return service;
    }
})();
